import { render, staticRenderFns } from "./RootPage.vue?vue&type=template&id=256c57c3"
import script from "./RootPage.vue?vue&type=script&lang=js"
export * from "./RootPage.vue?vue&type=script&lang=js"
import style0 from "./RootPage.vue?vue&type=style&index=0&id=256c57c3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports